<template>
    <section ref="refHero" class="slice job-page__hero">
        <div class="slice-content">
            <ShapeTopRight class="job-page__hero__shape" />
            <div class="job-page__hero__wrapper">
                <div>
                    <JobPageBreadcrumbs />
                    <JobPageTitle />
                    <JobPageDescription />
                    <div v-if="ctaUrl" class="job-page__hero__cta">
                        <VJoyButton :href="$withLocalePrefix(ctaUrl)" variant="main" rel="nofollow" data-component-source="category-landing-page">
                            {{ ctaLabel }}
                        </VJoyButton>
                    </div>
                </div>
                <div v-if="prismicImage" class="job-page__hero__image">
                    <PrismicImage :image="prismicImage" width="578" height="auto" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import {useComponentTracking} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import PrismicImage from '~/components/PrismicImage.vue';
    import ShapeTopRight from '~/components/shape/ShapeTopRight.vue';
    import {JOB_PAGE} from '~/keys';
    import JobPageBreadcrumbs from './JobPageBreadcrumbs.vue';
    import JobPageDescription from './JobPageDescription.vue';
    import JobPageTitle from './JobPageTitle.vue';

    const {prismicTemplate, prismicPage, jobPageConfig} = inject(JOB_PAGE) || {};
    const refHero = ref<HTMLElement | null>(null);

    const ctaLabel = jobPageConfig?.primary.heroCtaLabel || prismicPage?.data.heroCtaLabel || prismicTemplate?.data.heroCtaLabel;
    const ctaUrl = jobPageConfig?.primary.heroCtaUrl || prismicPage?.data.heroCtaUrl || prismicTemplate?.data.heroCtaUrl;
    const prismicImage = jobPageConfig?.primary.heroImage.url
        ? jobPageConfig?.primary.heroImage
        : prismicPage?.data.heroImage.url
          ? prismicPage?.data.heroImage
          : prismicTemplate?.data.heroImage;

    useComponentTracking(refHero);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__hero {
        @include mq.screen_lg(min) {
            margin-bottom: var(--joy-core-spacing-12);
        }

        .slice-content {
            position: relative;
            text-align: left;
        }

        &__wrapper {
            position: relative;

            @include mq.screen_md(min) {
                display: flex;
                gap: var(--joy-core-spacing-12);
                flex: 1 1;
                align-items: center;
            }
        }

        &__image {
            display: none;

            @include mq.screen_md(min) {
                display: block;
                max-width: 45%;

                img {
                    width: 100%;
                }
            }
        }
        &__shape {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            overflow: visible;
            width: 100%;
        }

        &__cta {
            margin-top: var(--joy-core-spacing-10);
        }
    }
</style>
